import React from "react"
import { ComparativoUnidadesContextProvider } from "./context/ComparativoUnidadesContextProvider"
import { ComparativoUnidades } from "./ComparativoUnidades"

export function Index() {
    return (
        <ComparativoUnidadesContextProvider>
            <ComparativoUnidades />
        </ComparativoUnidadesContextProvider>
    )
}
